// Element fetchers
export function getHtml(): HTMLElement {
  return document.documentElement;
}

export function getBody(): HTMLElement {
  return document.body;
}

export function getHeader(): HTMLElement | null {
  return document.body.querySelector('header');
}

export function getFooter(): HTMLElement | null {
  return document.body.querySelector('footer');
}

export function getLeaderboard(): HTMLElement | null {
  return document.body.querySelector('#leaderboard');
}

// Element height utils
export function getHeaderHeight(): number {
  const header = document.getElementsByTagName('header')[0];
  return header ? getHeight(header) : 0;
}

export function getSportsNavHeight(): number {
  const header = document.getElementById('sports-nav');
  return header ? getHeight(header) : 0;
}

export function getLeaderboardHeight(): number {
  const leaderboard = document.getElementById('leaderboard');
  return leaderboard ? getHeight(leaderboard) : 0;
}

export function getSubHeaderHeight(): number {
  const subHeader = document.getElementById('sub-header');
  return subHeader ? getHeight(subHeader) : 0;
}

export function getMidNavHeight(): number {
  const subHeader = document.getElementById('mid-nav');
  return subHeader ? getHeight(subHeader) : 0;
}

export function getSubeventHeaderHeight(): number {
  const subeventHeader = document.getElementById('subevent-header');
  return subeventHeader ? getHeight(subeventHeader) : 0;
}

export function getSubeventHeaderTabsHeight(): number {
  const subeventHeader = document.getElementById('subevent-header-tabs');
  return subeventHeader ? getHeight(subeventHeader) : 0;
}

export function getFooterHeight(): number {
  const footer = getFooter();
  return footer ? getHeight(footer) : 0;
}

export function getAllHeaderElementsHeight(): number {
  return (
    getHeaderHeight() +
    getSubHeaderHeight() +
    getMidNavHeight() +
    getSubeventHeaderHeight() +
    getSubeventHeaderTabsHeight() +
    getLeaderboardHeight()
  );
}

export function getWrapperElementHeight(): number {
  return getAllHeaderElementsHeight() + getFooterHeight();
}

/**
 * @deprecated Use getWrapperElementHeight instead
 */
export function getWrapperElementHeights(): number {
  return getHeaderHeight() + getSubeventHeaderHeight() + getLeaderboardHeight() + getFooterHeight();
}

// Attribute helpers
export function getHeight(el: HTMLElement | null): number {
  return getNumericStyleAttr(el, 'height') || 0;
}

export function setHeight(el: HTMLElement | null, height: number | string): void {
  if (!el) return;

  if (typeof height === 'string') {
    el.style.height = height;
  } else {
    el.style.height = `${height}px`;
  }
}

export function getWidth(el: HTMLElement | null): number {
  return getNumericStyleAttr(el, 'width') || 0;
}

function getNumericStyleAttr(el: HTMLElement | null, attr: keyof CSSStyleDeclaration): number | undefined {
  if (el) {
    const attribute = getComputedStyle(el, null)[attr];
    if (typeof attribute === 'string') {
      return parseFloat(attribute.replace('px', ''));
    } else if (typeof attribute === 'number') {
      return attribute;
    }
  }
  return undefined;
}
